"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var defaultTabList = {
    details: true,
    personal: true,
    contact: true,
    ethnicity: true,
    medical: true,
    address: true,
    restrictions: true,
    disabilities: true,
    comments: true,
    carers: true,
};
function defaultClientTabs(trans, switches) {
    return [
        {
            label: trans('optiiva::labels.details'),
            enabled: switches ? switches.details : defaultTabList.details,
            children: [
                {
                    label: trans('optiiva::labels.personal'),
                    identifier: 'details.personal',
                    enabled: switches ? switches.personal : defaultTabList.personal,
                },
                {
                    label: trans('optiiva::labels.contact'),
                    identifier: 'details.contact',
                    enabled: switches ? switches.contact : defaultTabList.contact,
                },
                {
                    label: trans('optiiva::labels.ethnicity'),
                    identifier: 'details.ethnicity',
                    enabled: switches ? switches.ethnicity : defaultTabList.ethnicity,
                },
                {
                    label: trans('optiiva::labels.medical'),
                    identifier: 'details.medical',
                    enabled: switches ? switches.medical : defaultTabList.medical,
                },
                {
                    label: trans('optiiva::labels.address'),
                    identifier: 'details.address',
                    enabled: switches ? switches.address : defaultTabList.address,
                },
                {
                    label: trans('optiiva::labels.restrictions'),
                    identifier: 'details.restrictions',
                    enabled: switches ? switches.restrictions : defaultTabList.restrictions,
                },
                {
                    label: trans('optiiva::labels.carer'),
                    identifier: 'details.carers',
                    enabled: switches ? switches.carers : defaultTabList.carers,
                },
            ],
        },
        {
            label: trans('optiiva::labels.disabilities'),
            identifier: 'disabilities',
            enabled: switches ? switches.disabilities : defaultTabList.disabilities,
        },
        {
            label: trans('optiiva::labels.comments'),
            identifier: 'comments',
            enabled: switches ? switches.comments : defaultTabList.comments,
        },
    ];
}
exports.default = defaultClientTabs;
//# sourceMappingURL=defaultClientTabs.js.map